import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HistoryButtonClass } from "../historyButtonClass";
import {
  RedoIcon,
  UndoIcon,
  ZoomInIcon,
  ZoomOutIcon,
} from "../../icons";
import { useJourneyPlanner } from "./JourneyPlannerContext";
import {
  JOURNEY_PLANNER_MAX_ZOOM,
  JOURNEY_PLANNER_MIN_ZOOM,
} from "./journeyPlannerHelpers";

function JourneyPlannerZoomControls() {
  const {
    canRedo,
    canUndo,
    handleZoomIn,
    handleZoomOut,
    redo,
    undo,
    zoomLevel,
  } = useJourneyPlanner();

  return (
    <div
      className="surface-grid-zoom d-flex align-items-center gap-1 p-1 overflow-hidden"
      role="group"
      aria-label="Journey planner history and zoom"
    >
      <button
        type="button"
        aria-label="Undo"
        title="Undo (Ctrl+Z)"
        disabled={!canUndo}
        className={HistoryButtonClass}
        onClick={undo}
      >
        <FontAwesomeIcon icon={UndoIcon} className="small" />
      </button>
      <button
        type="button"
        aria-label="Redo"
        title="Redo (Ctrl+Y)"
        disabled={!canRedo}
        className={HistoryButtonClass}
        onClick={redo}
      >
        <FontAwesomeIcon icon={RedoIcon} className="small" />
      </button>
      <div className="vr mx-1 my-1" />
      <button
        type="button"
        aria-label="Zoom out"
        title="Zoom out"
        disabled={zoomLevel <= JOURNEY_PLANNER_MIN_ZOOM}
        className={HistoryButtonClass}
        onClick={handleZoomOut}
      >
        <FontAwesomeIcon icon={ZoomOutIcon} className="small" />
      </button>
      <span className="text-secondary text-center">
        {Math.round(zoomLevel * 100)}%
      </span>
      <button
        type="button"
        aria-label="Zoom in"
        title="Zoom in"
        disabled={zoomLevel >= JOURNEY_PLANNER_MAX_ZOOM}
        className={HistoryButtonClass}
        onClick={handleZoomIn}
      >
        <FontAwesomeIcon icon={ZoomInIcon} className="small" />
      </button>
    </div>
  );
}

export default JourneyPlannerZoomControls;
